import * as React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { Link } from "react-router-dom";
import FiberNewIcon from '@mui/icons-material/FiberNew';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import WatchIcon from '@mui/icons-material/Watch';
import { model } from '../config/config';
import CategoryIcon from '@mui/icons-material/Category';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

export default function SimpleBottomNavigation() {
  const [value, setValue] = React.useState(0);

  return (
    <Box sx={{
         width: '100%',
         position: 'fixed',
         left: '0',
         bottom: '0',
         zIndex:'999',
         display: {
            md: 'none'
         },
         "& .MuiBottomNavigation-root": {
          backgroundColor: '#1E222B',
          borderTop: '1px solid #393d45',
         }
         }}>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        {/* <BottomNavigationAction label="Home" icon={<HomeRoundedIcon />} /> */}
        <BottomNavigationAction component={Link} to="/selectwatch/" label="Select" icon={<WatchIcon />} />
		<BottomNavigationAction component={Link} to={`/${model}/latest`} label="Latest" icon={<FiberNewIcon />} />
        <BottomNavigationAction component={Link} to={`/${model}/category`} label="Cateogry" icon={<CategoryIcon />} />
        <BottomNavigationAction component={Link} to={`/${model}/search`} label="Search" icon={<SearchRoundedIcon />} />
		 <BottomNavigationAction component={Link} to="/ourapp" label="Our Apps" icon={<PhoneIphoneIcon />} />
      </BottomNavigation>
    </Box>
  );
}
